// extracted by mini-css-extract-plugin
export default {"background":"EditPlan_background__Vzblt","main":"EditPlan_main__6xdgg","fadeIn":"EditPlan_fadeIn__SokZP","nav__variable":"EditPlan_nav__variable__VlxyE"};